<template>
  <div class="bg-container page">
    <!-- <img class="bg-img" src="/img/login/lgbg.png" /> -->
    <div class="bg-wrapper" style="background: url(/img/login/lgbg.png) no-repeat 50% / 100%;">
      <div class="login">
        <van-nav-bar class="nav-bar">
          <template #left>
            <van-icon name="arrow-left" color="#fff" @click="back()" />
          </template>
          <template #right>
            <div class="language" @click="$router.push('/language')">
<div v-if="lang == 'en'" class="langs">English</div>
	<div v-if="lang == 'zh'" class="langs">簡體中文</div>
	<div v-if="lang == 'ja'" class="langs">日本語</div>
	<div v-if="lang == 'kr'" class="langs">한국어</div>
            </div>
          </template>
        </van-nav-bar>
        <div class="wrapper">
        <div class="poster-brand">LOVE DESIRE 18+</div>
<!--          <div class="title">{{ $t("auth.login") }}</div> -->
          <div class="loginForm">
            <van-field
              v-model="username"
              clearable
              input-align="center"
              class="input"
              :placeholder="$t('auth.username_place')"
            >
              <template slot="left-icon">
                <img  src="/img/login/zh.png" />
              </template>
            </van-field>
            <van-field
              v-model="password"
              :type="passwordType"
              input-align="center"
              class="input"
              :placeholder="$t('auth.pwd_place')"
            >
              <template slot="right-icon">
                <van-icon
                  :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                  @click="switchPasswordType"
                />
              </template><template slot="left-icon">
                <img  src="/img/login/mm.png" />
              </template>
            </van-field>
            <!-- <div class="reset-text">
              <span>{{$t("auth.forgetpwd")}}?</span>
            </div> -->
            <div @click="toRegister()" class="register-text">
              <span>{{$t("auth.no_account")}}</span>
            </div>
            <van-button
              class="login-btn"
              :class="{'login-btn-on': canSubmit}"
              type="primary"
              size="normal"
              @click="doLogin()"
              >{{$t("auth.login")}}</van-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "inputValue",
    event: "input",
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      username: "",
      lang: 'kr',
      password: this.inputValue,
      passwordType: "password",
    };
  },
  computed: {
    canSubmit() {
      return !!(String(this.username || '').trim() && String(this.password || '').trim());
    }
  },
  mounted(){
    // localStorage.setItem("lang", 'ms_my');
    this.lang = this.$t("auth.lang");
  },
  methods: {
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },
    toRegister() {
      this.$router.push("Register");
    },
    doLogin() {
      if (
        this.username === "" ||
        this.username === null ||
        this.username === undefined
      ) {
        this.$toast(this.$t("auth.username_place"));
        return false;
      }
      if (
        this.password === "" ||
        this.password === null ||
        this.password === undefined
      ) {
        this.$toast(this.$t("auth.pwd_place"));
        return false;
      }
      this.$http({
        url: "member_login",
        method: "get",
        data: { 
          username: this.username, 
          password: this.password,
          // lang: this.lang
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data.id);
          this.$router.push("Mine");
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.login {
  height: 100%;
}
.bg-container .bg-wrapper .login .nav-bar {
  background: 0 0;
}

.language{
		position: absolute;
		top: 20px;
		right: 20px;
		height: 62px;
		width: 240px;
		img{
			height: 100%;
		}
	}
.langs{
	padding: 0 20px;
	line-height: 80px;
	font-size: 28px;
	color: #fff;
	border: 1px solid #fff;
}
.login .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.logo-container {
  margin: 0 auto;
  width: 45%;
}
.logo-container .logo-wrapper {
  position: relative;
  padding-bottom: 62.5%;
}
.logo-container .logo-wrapper .logo-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}
.login .wrapper .title {
  line-height: 100px;
  text-align: center;
  font-size: 45px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 5px;
}
.poster-brand {
  margin: 4.4rem auto 2rem;
  text-align: center;
  color: #fff;
  font-size: 56px;
  font-weight: 800;
  letter-spacing: 4px;
  line-height: 1.2;
  text-shadow: 0 4px 18px rgba(0, 0, 0, 0.45);
}
.login .wrapper .loginForm {
  padding: 20px 40px;
}
.login .wrapper .loginForm .input {
		width: 100%;
      height: 3.66667rem;
      margin: 1rem auto;
      border-radius: .33333rem;
      overflow: hidden;
      background: rgba(79, 79, 79, .8);
      display: flex ;
      justify-content: flex-start;
      align-items: center;
      padding: 0 2.33333rem;
}
::v-deep .van-field__right-icon .van-icon {
  font-size: 50px;
}
::v-deep .van-field__control{
	font-size: 28px;
	line-height: 40px;text-align: left;padding-left: 30px;color:#fff
}
::v-deep .van-icon {
  font-size: 50px;
}
.login .wrapper .loginForm .reset-text {
  margin: 30px 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.login .wrapper .loginForm .reset-text span {
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 15px;
}
.login .wrapper .loginForm .register-text {
  margin: 60px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login .wrapper .loginForm .register-text span {
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 20px;
}
.login .wrapper .loginForm .active {
}
.login .wrapper .loginForm .login-btn {
  margin-top: 0px;
  width: 100%;
  height: 100px;
  color: #fff;
  background: #cacacc !important;
  border-radius: .33333rem;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  transition: background .2s, box-shadow .2s, opacity .2s;
}
.login .wrapper .loginForm .login-btn.login-btn-on {
  background: linear-gradient(180deg, #fc78af, #f22678) !important;
  box-shadow: 0 8px 20px rgba(242, 38, 120, .35);
}
</style>
